export default __webpack_public_path__ + "static/media/fleet-card-selected.8359e705.svg";